<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Withdrawal') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to initiate a withdrawal</span>
            </div>

            <step-container :current_step="1" :step_list="stepList"></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <h3 class="pl-3 pt-3 pb-2">{{ $t('Select Withdrawal') }}</h3>

                            <div class="p-2 mb-4">
                                <div class="row mt-4">
                                    <div class="col-lg-6 col-md-12 pb-5">

                                        <div class="block-item account-type p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center text-center">
                                                <div class="fz-20 fw-700">{{ $t('Same Name') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Withdrawal') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Information') }}</div>
                                                    <div>
                                                        <ul>
                                                            <li>The withdrawal account is limited to the domestic and
                                                                foreign accounts with the same name as the individuals /
                                                                enterprise or loegal person.</li>
                                                            <li>You can add eligible accounts for withdrawal in the
                                                                “Withdrawal Account” menu.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <button class="d-block btn btn-primary w-100 py-2"
                                                @click="goWithdrawal('same-name')">{{ $t('Select')
                                                }}</button>
                                        </div>

                                    </div>

                                    <div class="col-lg-6 col-md-12 pb-5">

                                        <div class="block-item account-type p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center text-center">
                                                <div class="fz-20 fw-700">{{ $t('Different Name') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Withdrawal') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Information') }}</div>
                                                    <div>
                                                        <ul>
                                                            <li>Supports payments to suppliers in RMB and foreign
                                                                currency.</li>
                                                            <li>Foreign currency payments can be made via SWIFT in the
                                                                name of the payee (POBO).</li>
                                                            <li>Foreign currency payments can be made to more than 30
                                                                countries around the world through the local clearing
                                                                network (LOCAL), reducing payment costs.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <button class="d-block btn btn-primary w-100 py-2"
                                                @click="goWithdrawal('different-name')">{{ $t('Select')
                                                }}</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import stepContainer from "@/components/CardManagement/stepContainer";

export default {
    name: 'withdrawal-type',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            stepList: ["Select Withdrawal", "Fill Information", "Withdrawal Summary"]
        }
    },
    components: {
        LoaderComponent,
        stepContainer
    },
    methods: {
        goWithdrawal(type) {
            this.$router.push({
                path: type
            });
        }
    },
    mounted() {

    }
};
</script>

<style scoped>
ul li {
    list-style: disc;
}

.point .number {
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}

.account-type:hover {
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}

.block-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
</style>